import * as Const from "../config/const";
import {getLanguage} from "../actions/commands";

export default class Bios {
    constructor(bios){
        const language = getLanguage() === 'pt-br'
        this.id = bios.bio_id
        this.title = language?bios.bio_titulo_pt:bios.bio_titulo_en
        this.description = language?bios.bio_corpo_pt:bios.bio_corpo_en
        this.src = `${Const.defaults.image_base_url}${(language?bios.bio_imagem_pt:bios.bio_imagem_en)}`
    }
}


// WEBPACK FOOTER //
// ./src/models/bios.js